import { Zap } from "lucide-react";
import { isDayInCurrentWeekStreak } from "@/utils/studyStreak";
import { useTranslation } from "react-i18next";
import { getLocalizedWeekdayLabels } from "@/utils/weekdays";
import { useMemo } from "react";

interface ExamResultStreakCardProps {
  image: string;
  streakDays?: number;
  streakEndsToday?: boolean;
}

export function ExamResultStreakCard({ image, streakDays = 0, streakEndsToday = false }: ExamResultStreakCardProps) {
  const { i18n, t } = useTranslation();
  const currentDayIndex = (new Date().getDay() + 6) % 7;
  const dayLabels = useMemo(() => getLocalizedWeekdayLabels(i18n.language), [i18n.language]);
  return (
    <section className="dp-card flex h-[666px] w-[360px] shrink-0 flex-col items-center overflow-hidden px-4 py-6">
      <div className="relative flex h-[340px] w-full items-center justify-center overflow-hidden rounded-full bg-[radial-gradient(circle,#fff1c7_0_38%,#fff8e8_39%_54%,transparent_55%)]">
        <img alt="" className="h-[250px] w-[250px] object-contain" src={image} />
      </div>
      <strong className="mt-4 text-[88px] font-semibold leading-none text-[var(--dp-brand-button)]">{streakDays}</strong>
      <span className="mt-2 text-sm font-semibold uppercase text-[#0a0c11]">{t("study.day_streak_label")}</span>
      <div className="mt-auto grid w-full grid-cols-7 gap-2">
        {dayLabels.map((day, index) => (
          <div className="flex flex-col items-center gap-3" key={`${day}-${index}`}>
            <span className={`flex h-9 w-9 items-center justify-center rounded-full ${isDayInCurrentWeekStreak(index, currentDayIndex, streakDays, streakEndsToday) ? "bg-[var(--dp-brand-button)] text-white" : "border border-[#dddfe4] text-[#c2c6cc]"}`}>
              <Zap aria-hidden="true" className="h-5 w-5 fill-current" />
            </span>
            <span className={`text-sm ${isDayInCurrentWeekStreak(index, currentDayIndex, streakDays, streakEndsToday) ? "font-semibold text-[#0a0c11]" : "text-[#b6bac1]"}`}>{day}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
